<template>
  <div>
    <VUEHeader/>
    <section id="content" class="m-t-lg wrapper-md animated fadeInUp bg-dark" :style="PageStyle" @keydown.enter = "OnClickLogin">       
      <div class="container aside-xxl">      
        <section class="panel panel-default bg-white m-t-lg">
          <header class="panel-heading text-center">
            <strong>{{ this.GetTraduzioneLabel('VUELogin','TKN_LOGIN_TITOLO',this.LinguaUtente) }}</strong>
          </header>
          <VUEModal v-if="RecuperoPsw" :Titolo="this.GetTraduzioneLabel('VUELogin','TKN_PASSWORD_RECOVERY',this.LinguaUtente)" :Altezza="'200px'" :Larghezza="'800px'" :PathLogo="require('@/assets/images/LogoDMS.png')" :Programma="'DMSEW'"
                    @onClickChiudiModal="AnnullaRecupero">
            <template v-slot:Body>
                <div class="col-md-12">                
                    <p>{{ this.GetTraduzioneLabel('VUELogin','TKN_LOGIN_TESTO',this.LinguaUtente) }}</p>
                    <br>
                    <input class="form-control" style="width:40%" type="text" v-model="NomeUtente">
                </div>
            </template>
            <template v-slot:Footer>
              <button type="button" class="btn btn-danger" style="float:right;margin-left:10px;font-weight:bold;width:18%" @click="AnnullaRecupero" data-dismiss="modal">{{ this.GetTraduzioneLabel('VUELogin','TKN_LOGIN_CANCEL',this.LinguaUtente) }}</button>
              <button type="button" class="btn btn-info" style="float:right;font-weight:bold;width:18%" @click="ConfermaRecupero" data-dismiss="modal">{{ this.GetTraduzioneLabel('VUELogin','TKN_LOGIN_SEND',this.LinguaUtente) }}</button>
            </template>
          </VUEModal> 
          <div class="panel-body wrapper-lg">
            <div style="display: flex; align-items: center; justify-content: center">
              <img src="@/assets/images/LogoDMS.png">
            </div>
            <div class="form-group">
              <label class="control-label">{{ this.GetTraduzioneLabel('Generic','TKN_USERNAME',this.LinguaUtente) }}</label>
              <input type="text" :placeholder="this.GetTraduzioneLabel('Generic','TKN_USERNAME',this.LinguaUtente)" v-model="UserName" class="form-control input-lg">
            </div>
            <div class="form-group">
              <label class="control-label">{{ this.GetTraduzioneLabel('Generic','TKN_PASSWORD',this.LinguaUtente) }}</label>
              <input type="password" :placeholder="this.GetTraduzioneLabel('Generic','TKN_PASSWORD',this.LinguaUtente)" v-model="Password" class="form-control input-lg">
            </div>
            <div class="checkbox">
              <label>
                <input type="checkbox" v-model="Ricordami"> {{ this.GetTraduzioneLabel('VUELogin','TKN_LOGIN_REM_ME',this.LinguaUtente) }}
              </label>
            </div>
            <a class="pull-right m-t-xs" style="cursor:pointer" @click="RecuperoPsw = true"><small>{{ this.GetTraduzioneLabel('VUELogin','TKN_LOGIN_FORGOT_PW',this.LinguaUtente) }}?</small></a>
            <button class="btn btn-primary" @click="OnClickLogin">{{ this.GetTraduzioneLabel('VUELogin','TKN_LOGIN_LOG',this.LinguaUtente) }}</button>
            <div class="line line-dashed"></div>
          </div>
        </section>
      </div>
    </section>
    <VUELegalFooter />
  </div>
</template>

<script>
import VUEHeader from '@/components/FrameComponentsMultiPurpose/VUEHeader.vue';
import { COLORI_PANTONE, LOCALSTORAGE, SystemInformation, LINGUA_DEFAULT } from '../SystemInformation.js'
import VUEModal from '@/utils/VUEModal.vue';
import MixInsGestioneTraduzioni from '@/utils/MixInsGestioneTraduzioni';
import VUELegalFooter from '@/components/FrameComponentsMultiPurpose/VUELegalFooter.vue';

export default 
{
    mixins: [ MixInsGestioneTraduzioni ],
    name: "VUELogin",
    data() 
    {
     return { 
               UserName        : '',
               Password        : '',
               Ricordami       : true,
               RecuperoPsw     : false,
               NomeUtente      : '',
               PageStyle       : {'background-color' : COLORI_PANTONE.Bianco},
               LinguaUtente    : localStorage.getItem(LOCALSTORAGE.LanguageDMSEW) || LINGUA_DEFAULT
            };
    },
    components: 
    {
       'VUEHeader' : VUEHeader ,
        VUEModal,
        VUELegalFooter
    },
    methods: 
    {
       OnClickLogin()
       {
          var self = this;
          SystemInformation.AdvQuery.Login(this.UserName,
                                           this.Password,
                                           this.Ricordami,
                                           function(TokenRememberMe)
                                           {
                                             if(TokenRememberMe == undefined)
                                                localStorage.removeItem(LOCALSTORAGE.TokenRememberMe);
                                             else localStorage.setItem(LOCALSTORAGE.TokenRememberMe,TokenRememberMe);
                                             SystemInformation.GetUserInformation(function()
                                             {
                                                if (SystemInformation.UserInformation.PrimoAccesso != 'F')
                                                  self.$router.push('/PrimoAccesso')
                                                else
                                                  self.$router.push('/appMainWindow/Dashboard');
                                             },
                                             function(HTTPError,SubHTTPError)
                                             {
                                               SystemInformation.HandleError(HTTPError,SubHTTPError);
                                             });
                                             
                                           },
                                           function(HTTPError,SubHTTPError)
                                           {
                                             SystemInformation.HandleError(HTTPError,SubHTTPError);
                                           });
       },

       AnnullaRecupero()
       {
         this.RecuperoPsw = false
         this.NomeUtente = ''
       },

       ConfermaRecupero()
       {
         this.RecoverPassword(this.AnnullaRecupero)
       },

       RecoverPassword(OnSuccess)
       {
           let Parametri = {NomeUtente : this.NomeUtente}
           let Self = this
           SystemInformation.AdvQuery.ExecuteExternalScript('ExtraSendMailRecuperoPsw',Parametri,function(Answer) 
           {
               if(Answer.Risposta == 'MAIL_INVIATA')
               {
                   OnSuccess();
                   alert(Self.GetTraduzioneLabel('VUELogin','TKN_LOGIN_EMAIL_SEND',Self.LinguaUtente))
               }
               else 
               {
                   if(Answer.ErroreMail != undefined)
                      alert(Self.GetTraduzioneLabel('VUELogin','TKN_LOGIN_ERR_EMAIL_SEND',Self.LinguaUtente))
                   if (Answer.MessaggioUtente)
                      alert(Self.GetTraduzioneLabel('VUELogin','TKN_LOGIN_ERR_ACC_EXIST',Self.LinguaUtente))                   
               }
           },
           function(ErrorMessage,DescrErrore)
           {
              alert(ErrorMessage + '[' + DescrErrore + ']')
           });
       },
    },

    mounted()
    {
      setTimeout(() => { this.$forceUpdate() }, 50);
    },

    beforeMount()
    {
      if(SystemInformation.AdvQuery.CurrentUserLogged)
          if (this.$router.currentRoute.value.fullPath == "/")
              this.$router.push('/appMainWindow/Dashboard') 
    }
};
</script>